export default {
	'THEME': 'negishi',
	"FEATURE_ADDITIONALPRODUCTS": true,
	"FEATURE_CHILDPRODUCTS": true,
	"FEATURE_LIMITEDSTOCK": true,
	"FEATURE_ORDERBOX_DELIVERY": true,
	"FEATURE_ORDERBOX_TAKEAWAY": true,
}
